import {Immutable} from 'immer';
import {Factories} from './factory.js';
import {PeerId, Restrictions} from './common.js';
import {GwRequestId} from './pending-requests.js';
import {Context, ContextData} from './context.js';
import {DomainKeys} from './state.js';
import {PeerMessage, RequestMessage} from '../../common/types/messages.js';

// export const activityDomain: unique symbol = Symbol("activity-domain");
export const activityDomain = DomainKeys.Activity;

export type ActivityPeer = Immutable<{
    type: string,
    name?: string,
    configuration?: object
}>

export type ActivityType = Immutable<{
    name: string,
    owner_type: ActivityPeer
    helper_types?: ActivityPeer[]
    default_context?: ContextData
    visibility?: Restrictions
}>

export type ActivityChild = Immutable<{
    type: string,
    context: Context,
    owner: PeerId,
    participants?: Set<PeerId>
    properties?: unknown
    children?: ActivityChildren
}>;
export type ActivityId = string;
export type ActivityChildren = { [id: ActivityId]: ActivityChild };
export type Activity = Immutable<{
    // the activity id generated by the gateway
    id: ActivityId,
    // the activity type
    type: string,
    // activity's own context
    contextId: string,
    // id of the peer that has created it
    initiator: PeerId
    // flag signaling if the activity is ready (i.e. owner is ready)
    'ready?'?: boolean
    // owner peer id
    owner?: PeerId
    //collection of participant ids
    participants?: Set<PeerId>
    //collection of ready members of the activity. once a member becomes ready, its moved from the participants collection here
    readyMembers?: Set<PeerId>
    // collection of activities that are direct children
    children?: ActivityChildren

    gatewayRequests?: Set<GwRequestId>
    reloading?: Set<string>
    clientRequest?: PeerMessage & RequestMessage
    read_permissions?: Restrictions
    write_permissions?: Restrictions

}>

export type ActivityDomain = Immutable<{
    restrictions: Exclude<Restrictions, 'cluster'>
    factories?: Factories,
    member?: ActivityId
    owner?
    reload?: boolean
}>
